import React, { createContext, useContext, useState, useEffect, useRef } from 'react';
import ExpiryModal from '../components/common/ExpiryModal';
import { startExpiryChecker, clearExpiryChecker } from '../auth/login/expiryChecker';

const performLogout = () => {
  sessionStorage.removeItem('token');
  sessionStorage.removeItem('expiryTime');
  sessionStorage.clear();
  window.location.href = '/login';
};

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(sessionStorage.getItem('token') ?? null);
  const [userName, setUserName] = useState(null);

  const timeoutRef = useRef(null);
  const [showExpiryModal, setShowExpiryModal] = useState(false);

  const loginAuth = (token) => {
    console.log('login authService');
    setToken(token);
  };

  const logout = () => {
    setToken(null);
    sessionStorage.removeItem('token');
    sessionStorage.removeItem('expiryTime');
    window.location.href = '/login';
  };

  const getUserName = (userName) => {
    setUserName(userName);
  };

  const handleSessionExpired = () => {
    setShowExpiryModal(true);
  };

  const handleModalClose = () => {
    setShowExpiryModal(false);
    performLogout();
  };

  useEffect(() => {
    const expiry = sessionStorage.getItem('expiryTime');
    if (!expiry) return;

    if (timeoutRef.current) {
      clearExpiryChecker(timeoutRef.current);
    }

    timeoutRef.current = startExpiryChecker(expiry, handleSessionExpired);

    return () => {
      if (timeoutRef.current) {
        clearExpiryChecker(timeoutRef.current);
      }
    };
  }, [token]);


  return (
    <AuthContext.Provider value={{ token, loginAuth, logout, userName, getUserName }}>
      {children}

      <ExpiryModal
        isOpen={showExpiryModal}
        onClose={handleModalClose}
      />
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};